import { useTranslation } from "react-i18next";
import { useFilterMachineFixings } from "../../hooks/useFilterMachineFixings";
import { ProductCategory } from "../../shared/enums/ProductCategory";
import { productCardHelper } from "../../shared/helpers/productCardHelper";
import { ProductData } from "../../store/interfaces/productData";
import ProductCard from "../ProductCard/ProductCard";
import { localImages } from "../shared/localImages";
import { useProductTypes } from "../Tools/hooks/useProductTypes";
import "./ProductCategories.scss";

interface TiltrotatorInfo {
  count: number;
  maxWeight: number;
  minWeight: number;
}

interface ProductCategoriesProps {
  machineFixingsData: ProductData;
  onProductCategoryChange(productCategory: ProductCategory): void;
  selectedProductCategory: ProductCategory;
  tiltrotatorInfo: TiltrotatorInfo;
}

const ProductCategories = ({
  machineFixingsData,
  onProductCategoryChange,
  selectedProductCategory,
  tiltrotatorInfo,
}: ProductCategoriesProps) => {
  const { toolsProductTypes } = useProductTypes();

  const onChange = (productCategory: ProductCategory) => {
    onProductCategoryChange(productCategory);
  };

  const { filteredMachineFixings } = useFilterMachineFixings({
    machineFixingsData,
    selectedProductCategory: ProductCategory.MachineFixings,
    selectedTiltrotator: undefined,
  });

  const isSelected = (productCategory: ProductCategory): boolean =>
    productCategory === selectedProductCategory;
  const { t } = useTranslation([
    "productstep",
    "metrics",
    "machinefixings",
    "tools",
    "tiltrotator",
  ]);

  return (
    <div>
      <h3>{t("producttexts.chooseproductcategory")}</h3>
      <div className="productCategories">
        {tiltrotatorInfo.count > 0 && (
          <ProductCard
            content=""
            height={productCardHelper.height}
            localImage={localImages.RC5_produktbild}
            isSelected={isSelected(ProductCategory.Tiltrotator)}
            onChange={() => onChange(ProductCategory.Tiltrotator)}
            preContent={`${tiltrotatorInfo.count} ${t("pieces", {
              ns: "metrics",
            })}`}
            title={` ${t("tiltrotators", { ns: "tiltrotator" })}`}
            addTooltip={false}
            tooltipText=""
          />
        )}
        {filteredMachineFixings && filteredMachineFixings.length > 0 && (
          <ProductCard
            content=""
            height={productCardHelper.height}
            localImage={localImages.QC}
            isSelected={isSelected(ProductCategory.MachineFixings)}
            onChange={() => onChange(ProductCategory.MachineFixings)}
            preContent={`${filteredMachineFixings.length} ${t("pieces", {
              ns: "metrics",
            })}`}
            title={`${t("machinefixing", { ns: "machinefixings" })}`}
            addTooltip={false}
            tooltipText=""
          />
        )}
        {toolsProductTypes.length > 0 && (
          <ProductCard
            content=""
            height={productCardHelper.height}
            localImage={localImages.gravskopaTeeth}
            isSelected={isSelected(ProductCategory.Tools)}
            onChange={() => onChange(ProductCategory.Tools)}
            preContent={`${toolsProductTypes.length} ${t("categories", {
              ns: "tools",
            })}`}
            title={`${t("tools", { ns: "tools" })}`}
            addTooltip={false}
            tooltipText=""
          />
        )}
      </div>
    </div>
  );
};

export default ProductCategories;
